import React from 'react';
import './Banner.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import daily from '../../media/daily-telegraph.jpeg';
import newsau from '../../media/newsau.jpeg';
import sydney from '../../media/sydneymorning.jpeg';
import Carousel from './Carousel';


function OrderModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="fw-bold" id="contained-modal-title-vcenter">
                    500 Degree Steakhouse 🔥
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>Order Location 🌎</h4>
                <p>
                    Dear customer, we are based at <b>Kogarah</b> and <b>Cronulla</b>. Please select the branch you would like to order from. After your selection, we will immediately ask the store to prepare your order.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <div className="row w-100">
                    <div className="col-6 mx-auto">
                        <a target="_blank" href="https://500degrees-101299.square.site/">
                            <Button variant="warning" className="w-100" onClick={props.onHide}>Kogarah</Button>
                        </a>
                    </div>
                    <div className="col-6 mx-auto">
                        <a target="_blank" href="https://500-degrees-cronulla.square.site/">
                            <Button variant="dark" className="w-100" onClick={props.onHide}>Cronulla</Button>
                        </a>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

function BookingModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="fw-bold" id="contained-modal-title-vcenter">
                    500 Degree Steakhouse 🔥
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>Booking Location 🌎</h4>
                <p>
                    Dear customer, we are based at <b>Kogarah</b> and <b>Cronulla</b>. Please select the branch where you would like to book your table. After your selection, we will immediately ask the store to book a table for you.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <div className="row w-100">
                    <div className="col-6 mx-auto">
                        <a target="_blank" href="https://www.obee.com.au/500degreeskogarah/">
                            <Button variant="warning" className="w-100" onClick={props.onHide}>Kogarah</Button>
                        </a>
                    </div>
                    <div className="col-6 mx-auto">
                        <a target="_blank" href="https://www.obee.com.au/500degrees/">
                            <Button variant="dark" className="w-100" onClick={props.onHide}>Cronulla</Button>
                        </a>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}



const Banner = ({ banners }) => {
    const navigate = useNavigate();
    const [orderModalShow, setOrderModalShow] = React.useState(false);
    const [bookingModalShow, setBookingModalShow] = React.useState(false);
    console.log(banners);
    return (
        <div className="mb-lg-5 mb-5 text-white">
            <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
                <div className="carousel-inner">
                    {
                        banners.map((banner) => <Carousel
                            banner={banner}
                            key={banner._id}
                        />)
                    }
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
            <div className="d-flex justify-content-center">
                <div className="row highlight d-flex text-center shadow-lg bg-light col-11 col-lg-10 rounded-3 p-3 px-lg-5 py-lg-4">
                    <div className="text-dark mb-3">
                        <p className="mb-4 text-start">500 Degrees celebrates the incredible gift Australia has to offer by letting us use only the finest producers of meats and vegetables in the country, with the season’s best seafood prepared fresh every day. We are based on <b>Kogarah</b> and <b>Cronulla</b>.</p>
                        <div>
                            {/* <h1 className="fw-bold text-center" style={{ fontSize: '36px' }}>Featured on</h1> */}
                            <ul className="d-flex justify-content-center align-items-center p-0 featured-images mt-5 mb-4 mx-auto">
                                <span className="mx-auto mb-3 mb-lg-0">
                                    <p className="m-0 fw-bold">Featured on</p>
                                </span>
                                <span className="col-3 mx-auto  mb-3 mb-lg-0">
                                    <img className="img-fluid" src={sydney} alt="" />

                                </span>
                                <span className="col-3 mx-auto">
                                    <img className="img-fluid" src={newsau} alt="" />
                                    <img className="img-fluid mt-2" src={daily} alt="" />
                                </span>

                            </ul>
                        </div>
                    </div>
                    <div className="info-box py-4 py-lg-3 px-4 px-lg-3 d-flex flex-column flex-xl-row align-items-center justify-content-between mx-auto" style={{
                        backgroundColor: 'black'
                    }}>
                        <h4 className="m-0">500 Degrees - Steaks, Ribs, Seafoods</h4>
                        <div className="mt-3 mt-xl-0 d-flex flex-column flex-md-row align-items-center">
                            <a className="text-decoration-none" target="_blank" href="https://500-degrees-cronulla.square.site/s/order">
                                <button className="btn btn-success btn-lg rounded-pill me-md-2 d-flex align-items-center justify-content-center highlight-btns" >
                                    <span className="me-1">Order Online</span>
                                    <FontAwesomeIcon icon={faCircleArrowRight} />
                                </button>
                            </a>

                            <button className="btn btn-success btn-lg rounded-pill mt-2 mt-md-0 me-md-2 d-flex justify-content-center align-items-center highlight-btns" onClick={() => navigate('/book-table')}>
                                <span className="me-1">Book Table</span>
                                <FontAwesomeIcon icon={faCircleArrowRight} />
                            </button>
                        </div>
                    </div>
                    <div className="bg-dryage mt-3 d-flex align-items-center justify-content-center">
                        <button className="btn btn-warning btn-lg rounded-pill mt-2 mt-md-0 d-flex justify-content-center align-items-center highlight-btns" onClick={() => navigate('/dryage')}>
                            <span className="me-1">Dry Aged</span>
                            <FontAwesomeIcon icon={faCircleArrowRight} />
                        </button>
                    </div>
                    <OrderModal
                        show={orderModalShow}
                        onHide={() => setOrderModalShow(false)}
                    />
                    <BookingModal
                        show={bookingModalShow}
                        onHide={() => setBookingModalShow(false)}
                    />
                </div>
            </div>
        </div>

    );
};

export default Banner;